import angular from 'angular';
import { createManagerInstallation } from './services/manager-installation';

const moduleName = 'atc-manager-installation';

angular
    .module(moduleName, [])
    .factory('ManagerInstallation', [
        '$window',
        '$rootScope',
        ($window, $rootScope) => {
            const installation = createManagerInstallation($window, () =>
                $rootScope.$evalAsync(),
            );
            $rootScope.$on('$destroy', installation.dispose);
            return installation;
        },
    ])
    // Escuchar antes de resolver el login y cargar el template del sidebar.
    .run(['ManagerInstallation', angular.noop])
    .directive('managerInstallation', [
        'ManagerInstallation',
        'toastr',
        (installation, toastr) => ({
            restrict: 'A',
            scope: true,
            link: (scope) => {
                scope.installation = installation;
                scope.installManager = () =>
                    installation.install().catch(() => {
                        toastr.error(
                            'No se pudo abrir la instalación. Podés instalar la aplicación desde el menú del navegador.',
                        );
                    });
            },
        }),
    ]);

export default moduleName;
